export default {
	install(Vue) {
		Vue.config.keyCodes.home = 36;
		Vue.config.keyCodes.end = 35;
	}
};
